import { createReducer } from '@reduxjs/toolkit'
import { get, keys } from 'lodash'

import types from './types'

export { default as actions } from './actions'

export type State = {
  Holidays?: { Name: string; Active: boolean; Dates: string[] }[]
  Custom?: { From: string; To?: string }[] // date.DateRange
  Dates?: { [dateString: string]: boolean }
  mappedDates?: string[]
}

const mapBlackoutDates = (blackoutDates: State) => {
  const mappedDates = keys(get(blackoutDates, 'Dates'))
  return {
    ...blackoutDates,
    mappedDates,
  }
}

export const selectMappedDates = (state: { calendarBlackoutDates: State }): string[] =>
  state.calendarBlackoutDates?.mappedDates ?? []

export default createReducer<State>(
  {},
  {
    [types.UPDATE_BLACKOUT_DATES]: (state, action) => mapBlackoutDates(action.payload),
  },
)
